import React from 'react';
function BrokenImage({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="m2 2 20 20M10.41 10.41a2.002 2.002 0 0 1-2.83-2.83M13.5 13.5 6 21M18 12l3 3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59M21 15V5a2 2 0 0 0-2-2H9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default BrokenImage;
